import devConfig from './development.js'
import prodConfig from './production.js'
import qaConfig from './qa.js'

export default window.__ENV__ === 'PRODUCTION'
  ? prodConfig
  : window.__ENV__ === 'MASTER' 
    ? qaConfig
    : devConfig



// WEBPACK FOOTER //
// ./src/config/index.js